import { useEffect, useState } from "react";
import ButtonIconH from "./ButtonIconH";
import CheckBox from "./CheckBox";
import "../css/Insurance.css";
import { userData, focusElement, inputOnEnter } from "../js/utils";
import { post } from "../js/post";

export default function Insurance({ id, onClose }) {
  const [currentInsurance, setCurrentInsurance] = useState({
    fechaContratacion: "",
    fechaExpiracion: "",
    tipoSeguro: "",
  });

  const handleValue = (field, value) => {
    setCurrentInsurance((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const getInsurance = async () => {
    const response = await post("/support-extra/fichas/ObtenerSeguro.php", {
      token: userData.token,
      idFicha: id,
    });

    setCurrentInsurance(response);
  };

  const saveInsurance = async () => {
    const response = await post("/support-extra/fichas/GuardarSeguro.php", {
      token: userData.token,
      idFicha: id,
      ...currentInsurance,
    });

    if (response.idSeguro) {
      await getInsurance();
    }
  };

  useEffect(() => {
    focusElement(1);
    getInsurance();
  }, []);

  return (
    <div className="container-panel insurance-container">
      <div className="insurance-container-info">
        <div className="i-field">
          <span className="label">Contratación</span>
          <div className="input-data w-230">
            <input
              type="date"
              max="9999-12-31"
              step="1"
              tabIndex={1}
              className="input-field"
              value={currentInsurance.fechaContratacion}
              onChange={(e) => {
                handleValue("fechaContratacion", e.target.value);
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            ></input>
          </div>
        </div>
        <div className="i-field">
          <span className="label">Expiración</span>
          <div className="input-data w-230">
            <input
              type="date"
              max="9999-12-31"
              tabIndex={2}
              className="input-field"
              value={currentInsurance.fechaExpiracion}
              onChange={(e) => {
                handleValue("fechaExpiracion", e.target.value);
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            ></input>
          </div>
        </div>
        <div className="i-field">
          <span className="label">Sin seguro</span>
          <CheckBox
            tabIndex={3}
            active={currentInsurance.tipoSeguro === "N"}
            onClick={() => {
              handleValue("tipoSeguro", "N");
            }}
          ></CheckBox>
        </div>
        <div className="i-field">
          <span className="label">Titular del seguro</span>
          <CheckBox
            tabIndex={4}
            active={currentInsurance.tipoSeguro === "T"}
            onClick={() => {
              handleValue("tipoSeguro", "T");
            }}
          ></CheckBox>
        </div>
        <div className="i-field">
          <span className="label">Beneficiario del seguro</span>
          <CheckBox
            tabIndex={5}
            active={currentInsurance.tipoSeguro === "B"}
            onClick={() => {
              handleValue("tipoSeguro", "B");
            }}
          ></CheckBox>
        </div>
      </div>
      <div className="popup-buttons">
        <ButtonIconH
          text="Guardar"
          onClick={async () => {
            await saveInsurance();
            onClose();
          }}
        ></ButtonIconH>
      </div>
    </div>
  );
}
